/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Returns the package name.
 * @author samelh@google.com (Sam El-Husseini)
 */

export const id = process.env.PACKAGE_NAME;
